import { FieldPath, UseFormReturn } from 'react-hook-form';

import { LoadRefPillInput } from 'components/input/LoadRefPillInput';
import { RHFTextInput } from 'components/input/RHFTextInput';
import { NormalizedLoad } from 'types/Load';

type LoadBuildingTextInputProps = React.ComponentPropsWithoutRef<
  typeof RHFTextInput
> & { name: FieldPath<NormalizedLoad> };

export const LoadBuildingTextInput = (props: LoadBuildingTextInputProps) => (
  <RHFTextInput {...props} />
);

export type CustomerSectionFormProps = {
  formMethods: UseFormReturn<NormalizedLoad>;
  originalSuggestionData?: NormalizedLoad;
  isCreateMode?: boolean;
};

export function CustomerSectionForm({
  formMethods,
  originalSuggestionData,
  isCreateMode = false,
}: CustomerSectionFormProps) {
  const { control, getValues } = formMethods;

  return (
    <>
      <LoadBuildingTextInput
        name='customer.name'
        label='Name'
        readOnly={!isCreateMode}
        required={isCreateMode}
      />

      <LoadBuildingTextInput
        name='customer.email'
        label='Email'
        readOnly={!isCreateMode}
      />

      <LoadRefPillInput
        name='customer.refNumber'
        label='Ref #/ BOL'
        control={control}
        originalSuggestionData={originalSuggestionData || getValues()}
        autoSelectFirstOption={false}
      />

      <LoadRefPillInput
        name='poNums'
        label='PO #'
        control={control}
        originalSuggestionData={originalSuggestionData}
        disabled={true}
        autoSelectFirstOption={false}
      />
    </>
  );
}
